import React, { useCallback, useEffect, useLayoutEffect, useRef, useState, } from 'react';
import { Alert, Keyboard } from 'react-native';
import TextInputView from 'login/components/TextInputView';
import emoji from 'node-emoji';
import useColors from 'hooks/useColors';
import { logDeleteDetails } from './analytics';
import useNavigateAfterIssueStep from './hooks/useNavigateAfterIssueStep';
import { DeleteReasonID } from './reasons';
const strings = {
    [DeleteReasonID.BankDoesTheSame]: {
        title: 'What’s your bank?',
        placeholder: 'Name of the bank',
        event: 'Banks',
    },
    [DeleteReasonID.UseAnotherApp]: {
        title: 'What’s the name of the app?',
        placeholder: 'The app’s name',
        event: 'Apps',
    },
    [DeleteReasonID.DontSupportAccounts]: {
        title: 'Which account are we missing?',
        placeholder: 'The provider name',
        event: 'Accounts',
    },
};
const DeleteTextScreen = ({ navigation, route, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: strings[route.params.reason].title,
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary, route.params.reason]);
    const textInputRef = useRef(null);
    const [value, setValue] = useState('');
    const timeoutRef = useRef(undefined);
    useEffect(() => () => {
        clearTimeout(timeoutRef.current);
    }, []);
    const navigateAfterIssueStep = useNavigateAfterIssueStep();
    const openNext = useCallback(() => {
        Keyboard.dismiss();
        if (!value || !value.length) {
            timeoutRef.current = setTimeout(() => {
                Alert.alert(emoji.emojify('Hold on :dizzy:'), 'You must enter a name.', [{ text: 'OK', onPress: () => textInputRef.current?.focus() }]);
            }, 50);
            return;
        }
        navigateAfterIssueStep();
        logDeleteDetails('delete', value, strings[route.params.reason].event);
    }, [navigateAfterIssueStep, route.params, value]);
    return (<TextInputView title="" value={value} textRef={textInputRef} placeholder={strings[route.params.reason].placeholder} onChange={setValue} onPressContinue={openNext} autoComplete={undefined}/>);
};
export default DeleteTextScreen;
